import {
	Box,
	Checkbox,
	Divider,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Stack,
} from '@mui/material'
import Highlight from 'react-highlighter'

type Props = {
	searchTerm: string
	labelId: string
	ref: React.Ref<Element> | null
	item: CategorySearchResult
	checked: CategorySearchResult[]
	handleToggle: (item: CategorySearchResult) => () => void
	primaryText: string | null
	secondaryText: string | null
	primaryCaption: string | null
	secondaryCaption: string | null
}

export default function DialogListItem({
	ref,
	searchTerm,
	labelId,
	item,
	checked,
	handleToggle,
	primaryText,
	secondaryText,
	primaryCaption,
	secondaryCaption,
}: Props) {
	return (
		<Box ref={ref}>
			<ListItem disablePadding>
				<ListItemButton onClick={handleToggle(item)}>
					<ListItemIcon>
						<Checkbox
							edge="start"
							checked={checked.includes(item)}
							disableRipple
							inputProps={{ 'aria-labelledby': labelId }}
						/>
					</ListItemIcon>
					<ListItemText
						sx={{ width: '100%' }}
						id={labelId}
						slotProps={{
							primary: { component: 'div' },
							secondary: { component: 'div' },
						}}
						primary={
							<Stack width="100%" direction="row" justifyContent="space-between" gap={1}>
								<Highlight search={searchTerm}>{primaryText}</Highlight>
								<span>{secondaryText}</span>
							</Stack>
						}
						secondary={
							<Stack width="100%" direction="row" justifyContent="space-between" gap={1}>
								<Highlight search={searchTerm}>{primaryCaption}</Highlight>
								<Highlight search={searchTerm}>{secondaryCaption}</Highlight>
							</Stack>
						}
					/>
				</ListItemButton>
			</ListItem>
			<Divider />
		</Box>
	)
}
